/* RESPONSIBLE TEAM: team-automation-foundations */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import AdminSummary, { type AdminSummaryWireFormat } from '../admin-summary';

interface ConversationMarkedAsSpamWireFormat {
  admin_summary: AdminSummaryWireFormat;
}

export default class ConversationMarkedAsSpam implements RenderableData {
  readonly renderableType = RenderableType.ConversationMarkedAsSpam;
  readonly adminSummary: AdminSummary;

  constructor(adminSummary: AdminSummary) {
    this.adminSummary = adminSummary;
  }

  get creatingEntity() {
    return { type: EntityType.Admin, id: this.adminSummary.id };
  }

  static deserialize(json: ConversationMarkedAsSpamWireFormat): ConversationMarkedAsSpam {
    return new ConversationMarkedAsSpam(AdminSummary.deserialize(json.admin_summary));
  }
}
